import { i18n } from "../../../boot/i18n";
// import { store } from "../../../store";

export default {
  routes: [
    {
      name: "home",
      path: "",
      meta: {
        icon: "dashboard",
        title: i18n.global.t("Dashboard"),
      },
      component: () => import("pages/employee/Home"),
    },
    {
      name: "home-widget",
      path: "widget/:widget",
      props: true,
      meta: {
        icon: "dashboard",
        title: i18n.global.t("Dashboard"),
      },
      component: () => import("pages/employee/Home"),
    },
    {
      name: "notifications",
      path: "notifications/:page?",
      props: true,
      meta: {
        icon: "notification",
        title: i18n.global.tc("Notification", 100),
      },
      component: () => import("pages/Notifications"),
    },
    {
      name: "reminders",
      path: "reminders/:page?",
      props: true,
      meta: {
        icon: "snooze",
        title: i18n.global.tc("Reminder", 100),
      },
      component: () => import("pages/Notifications"),
    },
    {
      path: "old-schedule",
      redirect: { name: "old-schedule" },
    },
    {
      path: "lead-times",
      redirect: { name: "lead-times" },
    },
    {
      name: "time-clock",
      path: "time-clock",
      meta: { icon: "time_clock", title: i18n.global.t("Time Clock") },
      component: () => import("pages/employee/TimeClock"),
    },
  ],

  dialogs: [
    {
      name: "warehouse-location-barcodes",
      path: "/warehouse-location-barcodes",
      component: () =>
        import("../../../dialogs/employee/WarehouseLocationBarcodes"),
    },
  ],
};
